var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCoffee = function SvgIconCoffee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.25a1 1 0 0 1 1 1V4.5a1 1 0 0 1-2 0V2.25a1 1 0 0 1 1-1M11.25 1.25a1 1 0 0 1 1 1V4.5a1 1 0 1 1-2 0V2.25a1 1 0 0 1 1-1M15 1.25a1 1 0 0 1 1 1V4.5a1 1 0 1 1-2 0V2.25a1 1 0 0 1 1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 8.25a1 1 0 0 1 1-1h16.875a4 4 0 0 1 4 4V12a4 4 0 0 1-3.964 4 9.25 9.25 0 0 1-2.078 3.25H19.5a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h1.667A9.25 9.25 0 0 1 2 12.75zm6.035 11h6.43a7.25 7.25 0 0 0 3.73-4.42 1 1 0 0 1 .058-.204c.163-.609.247-1.24.247-1.876v-3.5H4v3.5a7.25 7.25 0 0 0 4.035 6.5M20.5 9.35v3.4q0 .59-.074 1.173A2 2 0 0 0 21.875 12v-.75a2 2 0 0 0-1.375-1.9",
    clipRule: "evenodd"
  }))));
};
export default SvgIconCoffee;